import React, { useState, useEffect } from "react";
import Transactional from "./Transactional";
import {
  Box,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  Text,
  Flex,
} from "@chakra-ui/react";
import ProviderList from "./ProviderList";
import PrimaryButton from "../../components/themeComponents/PrimaryButton";
import { fetchEmailChannels } from '../../Services/api';

const EmailIntegration = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingChannel, setEditingChannel] = useState(null);

  const [emailChannels, setEmailChannels] = useState([]);
  const [transactionalUUID, setTransactionalUUID] = useState(null);
  const [promotional, setPromotional] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const handleOpenAddModal = () => {
    setEditingChannel(null);
    setIsModalOpen(true);
  };

  const handleEditChannel = (channel) => {
    setEditingChannel(channel);
    setIsModalOpen(true);
  };

  const fetchList = async () => {
    setIsLoading(true);
    try {
      const response = await fetchEmailChannels();
      const rawChannels = response.data.data || [];

      const parsedChannels = rawChannels.map(channel => ({
        ...channel,
        name: channel.name.replace(/^"|"$/g, '').trim(), // Remove surrounding quotes
        credentials: JSON.parse(channel.credentials)    // Parse JSON string → object
      }));

      setTransactionalUUID(response.data.default_transactional_uuid);
      setPromotional(response.data.default_promotional_uuid);
      setEmailChannels(parsedChannels);
    } catch (error) {
      console.error("Error fetching email channels:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchList();
  }, []);

  const handleModalClose = () => {
    setIsModalOpen(false);
    setEditingChannel(null);
    fetchList(); // Refresh after save/edit
  };

  return (
    <Box p={6} bg="gray.50" borderRadius="md" boxShadow="md">
      <Flex justifyContent="space-between" alignItems="center" mb={6}>
        <Text fontSize="20px" fontWeight="semibold">
          SMTP Settings Configuration
        </Text>
        <PrimaryButton label="Add Config +" onClick={handleOpenAddModal}>
          Add Config
        </PrimaryButton>
      </Flex>

      <ProviderList
        emailChannels={emailChannels}
        transactionalUUID={transactionalUUID}
        promotional={promotional}
        onRefresh={fetchList}
        isLoading={isLoading}
        onEdit={handleEditChannel}
      />

      <Modal isOpen={isModalOpen} size="2xl" onClose={handleModalClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>
            {editingChannel ? "Edit Configuration" : "Add Configuration"}
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody pb={6}>
            <Transactional
              editingChannel={editingChannel}
              onSave={handleModalClose}
            />
          </ModalBody>
        </ModalContent>
      </Modal>
    </Box>
  );
};

export default EmailIntegration;